// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

type isToastErrorState = {
    status: string;
    action: string;
    message: string;
};

const initialState: isToastErrorState = {
    status: "",
    action: "",
    message: "",
};
  
export const isToastErrorSlice = createSlice({
    name: "isToastError",
    initialState,
    reducers: {
        setIsToastError: (state, action: PayloadAction<{status: string, action: string, message: string}>) => {
            return { ...state, ...action.payload };
        },
        clearIsToastError: () => {
            return { status: "", action: "", message: "" };
        },
    },
});

export const { setIsToastError, clearIsToastError } = isToastErrorSlice.actions;

export const selectIsToastError = (state: RootState) => state.isToastError;

export default isToastErrorSlice.reducer;